import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class HandleErrorService {

  constructor(private toaster: ToastrService) { }

  public handleError(err: HttpErrorResponse){
    let errorMessage: string;
    let warningMessage: string;
    if (err.error instanceof ErrorEvent){

      errorMessage = `Ocorreu um erro: ${err.error.message}`; 
    } else {
      switch (err.status){
        case 401:
          warningMessage = `${status} Matrícula ou senha inválida!`
          break;
        case 403:
          warningMessage = `${status} Matrícula ou senha incorreta!!`
          break;
        case 404:
          warningMessage = `${status} Usuário não cadastrado! Por favor, utilize o link Primeiro Acesso!`
          break;
        case 422:
          warningMessage = `${status} Usuário bloqueado!`
          break;
        case 500:
          warningMessage = `${status} Não é possível realizar o login. Servidor encontra-se desligado!`
          break;
        
        default:
      errorMessage = `Algo está errado`
    }
    // this.toaster.error(errorMessage)
      if(warningMessage){
          this.toaster.warning(warningMessage)
        } else {
          this.toaster.error(errorMessage)
      }
    
   }
  }
}
